import { useState } from "react";
import PopupBtmAgreeUsage from "./PopupBtmAgreeUsage";
import PopupBtmAgreePrivacy from "./PopupBtmAgreePrivacy";

// PopupBtmAgree 컴포넌트 생성
function PopupBtmAgree({ setisShowAgree, setisCompleteAgree }) {
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [checkItems, setCheckItems] = useState({
    usage: false,
    privacy: false
  });
  
  const [isShowAgreeUsage, setisShowAgreeUsage] = useState(false);
  const [isShowAgreePrivacy, setisShowAgreePrivacy] = useState(false);

  const handleAllCheck = () => {
    const newValue = !isAllChecked;
    setIsAllChecked(newValue);
    setCheckItems({
      usage: newValue,
      privacy: newValue
    });
  };

  const handleSingleCheck = (key) => {
    const newCheckItems = {
      ...checkItems,
      [key]: !checkItems[key]
    };
    setCheckItems(newCheckItems);
    setIsAllChecked(Object.values(newCheckItems).every(value => value));
  };

  const handleComplete = () => {
    if (Object.values(checkItems).every(value => value)) {
      setisCompleteAgree(true);
      setisShowAgree(false);
    }
  };

  return (
    <div className="fixed bg-[rgba(0,0,0,0.7)] top-0 left-0 w-full h-full flex items-end justify-center z-10">
      <div className="bg-white w-full p-5 pt-10 min-h-64 rounded-t-2xl max-w-screen-md max-h-[calc(100%-67px)] overflow-auto flex flex-col relative">
        <h3 className="text-[#1B1C1E] text-left font-semibold text-[22px] mb-6">
          필수 약관 동의
        </h3>

        <div className="flex flex-col gap-5">
          <div className="p-4 border border-[#EAEBEC] rounded-lg">
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={isAllChecked}
                onChange={handleAllCheck}
                className="w-5 h-5 accent-[#313A4C] fixed left-[-9999px]"
              />
              {
                isAllChecked
                ? <img src='/assets/img/checkbox_circle_on.svg' alt="checkbox on" />
                : <img src='/assets/img/checkbox_circle_off.svg' alt="checkbox off" />
              }
              <span className="text-base font-semibold">약관 전체 동의</span>
            </label>
          </div>

          <div className="flex flex-col gap-4">
            <label className="flex items-center justify-between">
              <div className="flex items-center gap-2 ml-5">
                <input
                  type="checkbox"
                  checked={checkItems.usage}
                  onChange={() => handleSingleCheck('usage')}
                  className="w-5 h-5 accent-[#313A4C] fixed left-[-9999px]"
                />
                {
                  checkItems.usage
                  ? <img src='/assets/img/check_line_on.svg' alt="checkbox on" />
                  : <img src='/assets/img/check_line_off.svg' alt="checkbox off" />
                }
                <span className="text-[15px] text-[#1B1C1E]">시스템 이용약관에 동의합니다.</span>
              </div>
              <button className="text-[13px] text-[#878A92] underline" onClick={() => setisShowAgreeUsage(true)}>보기</button>
            </label>

            <label className="flex items-center justify-between">
              <div className="flex items-center gap-2 ml-5">
                <input
                  type="checkbox"
                  checked={checkItems.privacy}
                  onChange={() => handleSingleCheck('privacy')}
                  className="w-5 h-5 accent-[#313A4C] fixed left-[-9999px]"
                />
                {
                  checkItems.privacy
                  ? <img src='/assets/img/check_line_on.svg' alt="checkbox on" />
                  : <img src='/assets/img/check_line_off.svg' alt="checkbox off" />
                }
                <span className="text-[15px] text-[#1B1C1E]">시스템 개인정보처리방침에 동의합니다.</span>
              </div>
              <button className="text-[13px] text-[#878A92] underline" onClick={() => setisShowAgreePrivacy(true)}>보기</button>
            </label>
          </div>
        </div>

        <button
          className={`mt-8 h-[52px] rounded-lg font-semibold ${
            Object.values(checkItems).every(value => value)
              ? 'bg-[#313A4C] text-white'
              : 'bg-[#E1E2E4] text-[#8E8E95]'
          }`}
          onClick={handleComplete}
          disabled={!Object.values(checkItems).every(value => value)}
        >
          확인
        </button>
      </div>

      {isShowAgreeUsage && <PopupBtmAgreeUsage setisShowAgreeUsage={setisShowAgreeUsage} />}
      {isShowAgreePrivacy && <PopupBtmAgreePrivacy setisShowAgreePrivacy={setisShowAgreePrivacy} />}
    </div>
  );
}

export default PopupBtmAgree;